export default {
	rdc_cases: {
		en: "RDC Cases",
		ar: "قضايا مركز فض المنازعات",
	},
	registration_date: {
		en: "Registration Date",
		ar: "تاريخ التسجيل",
	},
	closure_date: {
		en: "Closure Date",
		ar: "تاريخ الإغلاق",
	},
	case_number: {
		en: "Case Number",
		ar: "رقم الدعوة",
	},
	case_type: {
		en: "Case Type",
		ar: "نوع الدعوى",
	},
	case_year: {
		en: "Case Year",
		ar: "سنة الدعوى",
	},
	case_status: {
		en: "Case Status",
		ar: "حالة الدعوى",
	},
};
